import React from 'react';

const PennyMLFrame = () => {
  return (
    // Wrapper div to ensure full height
    <div className="w-full flex-1 h-full">
      <iframe
        src="https://jasperdeasey.github.io/penny_ml/"
        title="Penny ML Project"
        className="w-full h-full"
        loading="lazy"
        style={{
          border: 'none',
          minHeight: '100vh', // Changed from 80vh to 100vh
        }}
      />
    </div>
  );
};

export default PennyMLFrame;